/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Hero_SteadyInputs */

const en_us2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estimated max strength`)
};

const pt_br2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de força máxima estimada`)
};

const es_419_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de fuerza máxima estimada`)
};

const pt_pt2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de força máxima estimada`)
};

const fr_fr2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de force max estimée`)
};

const de_de2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geschätzte Maximalkraft`)
};

const it_it2_progress_hero_steady = /** @type {(inputs: Progress_Hero_SteadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forza massima stimata`)
};

/**
* | output |
* | --- |
* | "estimated max strength" |
*
* @param {Progress_Hero_SteadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_hero_steady = /** @type {((inputs?: Progress_Hero_SteadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Hero_SteadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_hero_steady(inputs)
	if (locale === "es-419") return es_419_progress_hero_steady(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_hero_steady(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_hero_steady(inputs)
	if (locale === "de-DE") return de_de2_progress_hero_steady(inputs)
	if (locale === "it-IT") return it_it2_progress_hero_steady(inputs)
	return en_us2_progress_hero_steady(inputs)
});
export { progress_hero_steady as "progress.hero_steady" }